import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { loginWithGoogleSession } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/login", { replace: true });
      return;
    }
    const sid = decodeURIComponent(m[1]);
    (async () => {
      try {
        await loginWithGoogleSession(sid);
        // Clear hash
        window.history.replaceState({}, "", window.location.pathname);
        nav("/dashboard", { replace: true });
      } catch {
        nav("/login", { replace: true });
      }
    })();
  }, [nav, loginWithGoogleSession]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-app">
      <div className="text-sm font-mono text-muted-fg tracking-widest uppercase animate-pulse">
        /// Authenticating…
      </div>
    </div>
  );
}
